import React from 'react'
import { twMerge } from 'tailwind-merge'

export default function SocialMediaLink({ href, label, iconPath, className }) {
    return (
        <a href={href} className={twMerge("flex gap-2 justify-center items-center hover:font-semibold", className)} target='_blank' rel="noreferrer">
            <img className='w-4' src={iconPath} alt={label} />
            <p className='hidden md:block transition-all'>{label}</p>
        </a>
    )
}
